import { isUrl, isHttps } from 'utils/url'

export default path =>
  path.endsWith('/') || (isUrl(path) && !isHttps(path)) ? path : `${path}/`
